import { useContext } from 'react';
//
import { BetaContext } from 'context/Beta';

// ----------------------------------------------------------------------

const useBeta = () => {
  const context = useContext(BetaContext);

  if (!context) throw new Error('Beta context must be use inside BetaContextProvider');

  return context;
};

export default useBeta;
